import hu from './hu';
import en from './en';

export default {
  hu,
  en,
}